import {
    FETCH_CLINICS_REQUEST,
    FETCH_CLINICS_SUCCESS,
    FETCH_CLINICS_FAILURE,
    FETCH_CLINICS_COUNT_REQUEST,
    FETCH_CLINICS_COUNT_SUCCESS,
    FETCH_CLINICS_COUNT_FAILURE
} from "../actions/clinicActions";

const initialState = {
    clinicList: [],
    totalCount: 0,
    isLoading: false,
    countLoading:false,
    error: null
};

export const clinicReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CLINICS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_CLINICS_SUCCESS:
            return { ...state, clinicList: action.payload, isLoading: false };

        case FETCH_CLINICS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_CLINICS_COUNT_REQUEST:
            return { ...state, countLoading: true };

        case FETCH_CLINICS_COUNT_SUCCESS:
            return { ...state, totalCount: action.payload, countLoading: false };

        case FETCH_CLINICS_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        default:
            return state;
    }
};
